function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.333 2.54c.838.767.894 2.066.126 2.903L9.79 20.333a2.06 2.06 0 01-3.034 0L.54 13.566a2.052 2.052 0 01.126-2.903 2.06 2.06 0 012.907.127l4.698 5.116L20.425 2.666a2.06 2.06 0 012.908-.126z"
});

function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgTick;